import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

export const selectWarehousesState = (state: RootState) => state.warehouses;

export const selectAllWarehouses = createSelector([selectWarehousesState], (state) =>
  state.allIds.map((id) => state.byId[id])
);

export const selectWarehouseById = (id: string) =>
  createSelector([selectWarehousesState], (state) => state.byId[id]);

export const selectSelectedWarehouse = createSelector([selectWarehousesState], (state) =>
  state.selectedId ? state.byId[state.selectedId] : null
);

export const selectWarehouseFilters = createSelector(
  [selectWarehousesState],
  (state) => state.filters
);

export const selectFilteredWarehouses = createSelector(
  [selectAllWarehouses, selectWarehouseFilters],
  (warehouses, filters) => {
    return warehouses.filter((warehouse) => {
      const matchesSearch =
        !filters.search ||
        warehouse.name.toLowerCase().includes(filters.search.toLowerCase()) ||
        (warehouse.address?.vtc || '').toLowerCase().includes(filters.search.toLowerCase()) ||
        (warehouse.address?.state || '').toLowerCase().includes(filters.search.toLowerCase());

      const matchesState =
        !filters.state ||
        (warehouse.address?.state || '').toLowerCase() === filters.state.toLowerCase();

      return matchesSearch && matchesState;
    });
  }
);

export const selectWarehousesLoading = createSelector(
  [selectWarehousesState],
  (state) => state.isLoading
);

export const selectWarehousesError = createSelector(
  [selectWarehousesState],
  (state) => state.error
);
